(() => {
  if (customElements.get('thinkcar-discount-coupon')) return;

  class ThinkcarDiscountCoupon extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.tc-coupon__copy');
      if (!this.querySelector('[data-status]')) {
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.connectedCallback();
        });
        return;
      }
      this.label = this.querySelector('[data-copy-label]');
      this.status = this.querySelector('[data-status]');
      this.timer = this.querySelector('[data-tc-countdown]');
      this.originalLabel = this.label?.textContent || '';
      this.onCopy = () => this.copyCode();
      this.button?.addEventListener('click', this.onCopy);
      this.connected = true;
      this.updateDeadline();
      if (Number.isFinite(this.deadline) && this.deadline > Date.now()) {
        this.interval = setInterval(() => this.updateCountdown(), 1000);
      }
    }

    disconnectedCallback() {
      this.connected = false;
      cancelAnimationFrame(this.initFrame);
      clearInterval(this.interval);
      clearTimeout(this.copyTimeout);
      this.button?.removeEventListener('click', this.onCopy);
    }

    static parseDeadline(value) {
      const normalized = String(value || '')
        .trim()
        .replace(/[\u00a0\u202f]/g, ' ')
        .replace(/\s+/g, ' ');
      const match = /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})[ T]+(\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec(normalized);
      if (!match) return NaN;
      const [, year, month, day, hour, minute, second = '00'] = match;
      if (+year < 2000 || +month < 1 || +month > 12 || +day < 1 || +day > 31 || +hour > 23 || +minute > 59 || +second > 59) return NaN;
      const date = Date.UTC(+year, +month - 1, +day, +hour - 8, +minute, +second);
      const beijing = new Date(date + 8 * 3600000);
      return beijing.getUTCFullYear() === +year
        && beijing.getUTCMonth() === +month - 1
        && beijing.getUTCDate() === +day
        && beijing.getUTCHours() === +hour
        && beijing.getUTCMinutes() === +minute
        && beijing.getUTCSeconds() === +second
        ? date
        : NaN;
    }

    updateDeadline() {
      const value = this.dataset.deadline.trim();
      this.deadline = ThinkcarDiscountCoupon.parseDeadline(value);
      this.hidden = false;
      if (Number.isFinite(this.deadline)) {
        this.updateCountdown();
      } else {
        if (this.timer) this.timer.hidden = true;
        if (this.dataset.editor === 'true' && (value || this.timer)) {
          this.showEditorNote('Set a valid deadline in Beijing time (UTC+08:00): YYYY-MM-DD HH:mm. The countdown remains hidden until a valid deadline is set.');
        }
      }
    }

    updateCountdown() {
      if (!Number.isFinite(this.deadline)) {
        if (this.timer) this.timer.hidden = true;
        return;
      }
      const remaining = this.deadline - Date.now();
      if (remaining <= 0) {
        clearInterval(this.interval);
        if (this.timer) this.timer.hidden = true;
        this.hidden = this.dataset.editor !== 'true';
        if (!this.hidden) this.showEditorNote('This coupon has expired and is hidden on the storefront.');
        return;
      }
      if (!this.timer) return;
      const seconds = Math.ceil(remaining / 1000);
      this.timer.querySelector('[data-days]').textContent = String(Math.floor(seconds / 86400)).padStart(2, '0');
      this.timer.querySelector('[data-hours]').textContent = String(Math.floor(seconds % 86400 / 3600)).padStart(2, '0');
      this.timer.querySelector('[data-minutes]').textContent = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
      this.timer.querySelector('[data-seconds]').textContent = String(seconds % 60).padStart(2, '0');
      this.timer.hidden = false;
    }

    showEditorNote(message) {
      const note = this.querySelector('[data-editor-note]');
      if (note) { note.textContent = message; note.hidden = false; }
    }

    async copyCode() {
      if (!this.dataset.code.trim()) return;
      clearTimeout(this.copyTimeout);
      let copied = false;
      try {
        await navigator.clipboard.writeText(this.dataset.code);
        copied = true;
      } catch (_) {
        // Retain copy support in browsers without the Clipboard API.
        const field = document.createElement('textarea');
        field.value = this.dataset.code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
        document.body.appendChild(field);
        const focused = document.activeElement;
        const selection = document.getSelection();
        const ranges = selection ? Array.from({ length: selection.rangeCount }, (_, i) => selection.getRangeAt(i).cloneRange()) : [];
        try { field.select(); copied = document.execCommand('copy'); } catch (_) { copied = false; }
        finally {
          field.remove();
          focused?.focus({ preventScroll: true });
          if (selection) { selection.removeAllRanges(); ranges.forEach(range => selection.addRange(range)); }
        }
      }
      if (!this.connected) return;
      this.label.textContent = copied ? this.dataset.copied : this.originalLabel;
      this.status.classList.toggle('tc-coupon__status--success', copied);
      this.status.textContent = copied ? this.dataset.copied : this.dataset.copyError;
      this.copyTimeout = setTimeout(() => {
        this.label.textContent = this.originalLabel;
        this.status.textContent = '';
        this.status.classList.remove('tc-coupon__status--success');
      }, 2500);
    }
  }

  customElements.define('thinkcar-discount-coupon', ThinkcarDiscountCoupon);
})();


